import "core-js/modules/es6.regexp.split";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.starts-with";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.regexp.replace";
// Using this 3rd party lib to detect and transform url and hash path placeholders
//  https://github.com/pillarjs/path-to-regexp
// Using the following lib to stringify the query string
//  https://github.com/sindresorhus/query-string
import pathToRegExp from 'path-to-regexp';
import invariant from 'invariant';
import { stringify, parse } from 'query-string';
/**
 * NOTE: this is a hack ... the `path-to-regexp` parser parses everything
 * in parentheses as regex, which is problematic if the URL includes regex
 * as actual characters
 * This function encodes the URL for all parentheses that are not in context
 * of an actual named parameter, e.g. `:foo(...)`
 * @param  {[type]} path [description]
 * @return {[type]}      [description]
 */

export function encodePath(path) {
  if (!path) {
    return path;
  }

  var regex = /((:[a-zA-Z]+)*)\((.*?)\)/gm;
  return path.replace(regex, function (match, $1) {
    if (!$1) {
      // No match for leading `:...` pattern found!
      return match.replace('(', '%28').replace(')', '%29');
    }

    return match;
  });
}
/**
 * Create URL string from given route object and options
 * @param  {Object} route
 * @param  {Object} options
 * @return {string}
 */

export function parseRouteToUrl(route) {
  // NOTE: maybe change to `parseRouteToUrl (route, params)`
  invariant(_typeof(route) === 'object' && route !== null, 'Undefined route cannot be parsed!');
  invariant(route.path, 'Route cannot be parsed! The \'path\' needs to be defined!');
  invariant(route.path.startsWith('/'), 'Route cannot be parsed! The \'path\' needs to start with a leading slash!'); // Get placeholders from path and hash definitions

  var pathParams = [];
  var hashParams = [];
  var savePath = encodePath(route.path);
  var saveHash = encodePath(route.hash);
  pathToRegExp(savePath, pathParams);
  pathToRegExp(saveHash || '', hashParams);
  var params = [].concat(pathParams, hashParams);

  if (!route.params) {
    route.params = {};
  }

  if (params.length) {
    // Validate if all params are defined and if the defined values
    // match the placeholder patterns
    params.forEach(function (param) {
      if (!param.optional) {
        invariant(route.params[param.name], "Route cannot be parsed! Missing definition for '".concat(param.name, "' param!"));
        var p = route.params[param.name];
        invariant(new RegExp(param.pattern).exec(route.params[param.name]), "Route cannot be parsed! Value '".concat(p, "' for param '").concat(param.name, "' does not match the defined pattern '").concat(param.pattern, "'!"));
      }
    });
  } // Compile final path and hash strings with given params


  var compilePath = pathToRegExp.compile(savePath);
  var compileHash = route.hash ? pathToRegExp.compile(saveHash) : null;
  var finalPath = route.params ? compilePath(route.params) : route.path;
  var finalHash = route.hash ? compileHash(route.params) : route.hash; // NOTE: hack, to revert the encoding we do earlier for parenthesis in the URL
  // to avoid them being falsely detected as regex patterns in the url

  finalPath = finalPath ? finalPath.replace('%28', '(').replace('%29', ')') : finalPath;
  finalHash = finalHash ? finalHash.replace('%28', '(').replace('%29', ')') : finalHash; // Stringify query object if defined

  var finalQuery = route.query && _Object$keys(route.query).length ? stringify(route.query, {
    arrayFormat: 'bracket'
  }) : null; // Finally put URL together

  return "".concat(finalPath).concat(finalQuery ? "?".concat(finalQuery) : '').concat(route.hash ? "#".concat(finalHash) : '');
}
/**
 * Parses single URL string (incl. query params and hash) to route object
 * Also includes custom logic to allow for query params in the hash!
 * @param  {string} url
 * @return {Object}
 */

export function parseUrlToRoute(url) {
  invariant(url && url.startsWith('/'), 'URL cannot be parsed! It needs to start with a leading slash!'); // Use DOM to get url information

  var path, queryString, hash;

  if (url.includes('?')) {
    var querySplit = url.split('?');
    path = querySplit[0]; // Just split for the first `?`, re-join every possible other occurance
    // of the `?` symbol

    querySplit.shift();
    queryString = querySplit.join('?');
  } else {
    path = url;
  }

  if (queryString) {
    if (queryString.includes('#')) {
      var queryHashSplit = queryString.split('#');
      queryString = queryHashSplit[0];
      hash = queryHashSplit[1];
    }
  }

  if (path.includes('#')) {
    var pathSplit = path.split('#');
    path = pathSplit[0];
    hash = pathSplit[1];
  }

  if (hash && hash.includes('?')) {
    // CUSTOM: allow query strings in hash!
    // e.g. /foo/bar#some/hash?hello=world
    var hashQuerySplit = hash.split('?');
    hash = hashQuerySplit[0];
    queryString = hashQuerySplit[1];
  }

  invariant(path, 'URL cannot be parsed! Path could not be detected!');
  return {
    path: path,
    hash: hash || null,
    query: parseQueryString(queryString)
  };
}
/**
 * Get placeholders from given path or hash string
 * @param  {String} pathOrHash
 * @return {Array}
 */

export function getParams(pathOrHash) {
  var pathParams = [];
  pathToRegExp(pathOrHash, pathParams);
  return pathParams;
}
/**
 * Parse a given query string to a valid query object
 * @param  {String} queryString
 * @return {Object}
 */

export function parseQueryString(queryString) {
  var parsed = parse(queryString, {
    arrayFormat: 'bracket'
  }); // Some custom mapping

  for (var key in parsed) {
    if (parsed[key] === null) {
      parsed[key] = true;
    }
  }

  return parsed;
}
/**
 * Build a query string from a given query object
 * @param  {Object} queryObject
 * @return {String}
 */

export function buildQueryString(queryObject) {
  return stringify(queryObject, {
    arrayFormat: 'bracket'
  });
}